var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{attrs:{"size":"small","title":"地域分布图"}},[_c('div',{staticClass:"area-chart"},[_c('e-chart',{staticStyle:{"width":"100%","height":"100%"},attrs:{"options":_vm.options,"autoresize":"","dom-id":"opensource-area-chart"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }